import axios from 'axios'

export const client = axios.create({
  baseURL: 'https://api.beebotte.com/v1',
  params: { token: 'token_bmuesRP3A4qWDHcn' }
})
